var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useRef, useState } from 'react';
import { Layout as AntLayout } from 'antd';
import { Sider } from './Sider';
import { Layout as StyleLayout, Content, Wrapper } from './styled';
import { Header } from './Header';
import { useMedia } from '../../hooks/mediaQueries';
import { Drawer } from './Drawer';
import { useMenu } from '../Header/hooks';
import { SIDER_MENU_COLLAPSED_WIDTH } from './const';
import ScrollTopBottom from '../../components/ScrollTopBottom';
var Layout = function (_a) {
    var children = _a.children, chat = _a.chat, header = _a.header, sider = _a.sider, content = _a.content;
    var isMobile = useMedia().isMobile;
    var _b = __read(useState(false), 2), visibleDrawer = _b[0], setVisibleDrawer = _b[1];
    var showDrawer = useCallback(function () { return setVisibleDrawer(true); }, []);
    var onClose = useCallback(function () { return setVisibleDrawer(false); }, []);
    var logoToRoot = header.logoToRoot, logoExtra = header.logoExtra, logoUrl = header.logoUrl, navigationUrl = header.navigationUrl, getNavigation = header.getNavigation, navigationRequestOptions = header.navigationRequestOptions, hideMenu = header.hideMenu;
    var navigationMenuProps = useMenu({
        navigationUrl: navigationUrl,
        getNavigation: getNavigation,
        navigationRequestOptions: navigationRequestOptions,
        hideMenu: hideMenu,
    });
    var wrapperRef = useRef(null);
    var _c = content || {}, _d = _c.withScroller, withScroller = _d === void 0 ? false : _d, onClickScroll = _c.onClickScroll;
    return (React.createElement(StyleLayout, null,
        isMobile ? (React.createElement(Drawer, __assign({ onClose: onClose, visible: visibleDrawer, menu: (sider === null || sider === void 0 ? void 0 : sider.menu) || [], navigationMenuProps: navigationMenuProps }, sider))) : (React.createElement(Sider, __assign({ collapsedWidth: SIDER_MENU_COLLAPSED_WIDTH, logoToRoot: logoToRoot, logoExtra: logoExtra, logoUrl: logoUrl }, sider))),
        React.createElement(AntLayout, null,
            React.createElement(Header, __assign({ showDrawer: showDrawer }, header, { chat: chat, navigationMenuProps: navigationMenuProps })),
            React.createElement(Wrapper, { ref: wrapperRef, id: 'layout-scroll-content' },
                React.createElement(Content, null, children)),
            withScroller && (React.createElement(ScrollTopBottom, { containerRef: wrapperRef, onClickScroll: onClickScroll })))));
};
export default Layout;
//# sourceMappingURL=Layout.js.map